import FingerPrintJS from '@fingerprintjs/fingerprintjs';
import cookie from 'js-cookie';

const FINGER_PRINT_COOKIE_KEY = '_zm_fingerprint';

/**
 * Add FingerPrint cookie so that the BE is able to call the API which require it.
 * This is used for freetrial flows (buyTrial and add2trial).
 * @returns {Promise<boolean>}
 */
export async function addFingerPrintCookie() {
  if (!cookie.get(FINGER_PRINT_COOKIE_KEY)) {
    const fp = await FingerPrintJS.load();
    const result = await fp.get();
    cookie.set(FINGER_PRINT_COOKIE_KEY, result.visitorId, {
      expires: Date.now() + 365 * 24 * 3600 * 1000,
      path: '/',
      domain: window.SB?.cookieDomain ?? document.domain,
      secure: true
    });
  }
  return Promise.resolve(true);
}

